
import React from "react";
import { TabsList, TabsTrigger } from "@/components/ui/tabs";
import { LogIn, UserPlus } from "lucide-react";
import { tabItemVariants } from "@/components/ui/toggle";
import { useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";

type AuthTabsProps = {
  activeTab: "login" | "signup";
  onTabChange: (value: string) => void;
};

const AuthTabs = ({ activeTab, onTabChange }: AuthTabsProps) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const mode = searchParams.get("mode");
  
  // Don't show tabs for forgotPassword or resetPassword modes
  if (mode === "forgotPassword" || mode === "resetPassword") {
    return null;
  }
  
  return (
    <div className="px-6">
      <TabsList 
        className="grid grid-cols-2 w-full bg-transparent rounded-lg mt-4 mb-4 p-1.5 h-10"
      >
        <TabsTrigger 
          value="login"
          onClick={() => onTabChange("login")}
          className={cn(
            "rounded-full h-9 transition-all duration-300",
            activeTab === 'login' ? "bg-mono-outerSpace hover:bg-mono-outerSpace" : "hover:bg-mono-outerSpace/50"
          )}
        >
          <span className={`flex items-center justify-center gap-2 ${tabItemVariants({
            state: activeTab === 'login' ? 'active' : 'inactive'
          })}`}>
            <LogIn className="h-4 w-4" />
            <span>Login</span>
          </span>
        </TabsTrigger>
        <TabsTrigger 
          value="signup"
          onClick={() => onTabChange("signup")}
          className={cn(
            "rounded-full h-9 transition-all duration-300",
            activeTab === 'signup' ? "bg-mono-outerSpace hover:bg-mono-outerSpace" : "hover:bg-mono-outerSpace/50"
          )}
        >
          <span className={`flex items-center justify-center gap-2 ${tabItemVariants({
            state: activeTab === 'signup' ? 'active' : 'inactive'
          })}`}>
            <UserPlus className="h-4 w-4" />
            <span>Sign up</span>
          </span>
        </TabsTrigger>
      </TabsList>
    </div>
  );
};

export default AuthTabs;
